import { CsTagService } from "./";

export const tags = new CsTagService();
